import React, { FunctionComponent } from 'react';
import {ToastContainer} from 'react-toastify';
import {isDesktop} from '../utils/MediaQueries';

interface Props {
    children: any;
    className?: string;
}

const Main: FunctionComponent<Props> = ({ children, className }) => {

    return (
        <main>
            <ToastContainer
                position={isDesktop ? 'top-right' : 'bottom-center'}
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                toastClassName={'toast'}
            />
            { children }
        </main>
    );
};

export default Main;
